import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from '@algoan/dashboard/store/store';
import { currencySelector } from '@algoan/dashboard/store/selectors';

export const useFormatMoney = (): ((value: number) => string) => {
  const intl = useIntl();
  const currency = useSelector(currencySelector);

  const formatMoney = useCallback(
    (value: number): string =>
      intl.formatNumber(value, { style: 'currency', currency: currency === 'GBP' ? 'GBP' : 'EUR' }),
    [intl, currency],
  );

  return formatMoney;
};
